<div class="wrapperStyle  ">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>
    <div id = "mainContainerDiv" class=" tab inner-tab-container dashboardContainer main-background topSpace main-container">
      <app-search-results [resultGridList]="data"></app-search-results>
      <!-- Nav tabs -->
      <!-- <ul class="nav nav-tabs cup-detail-header" role="tablist">
      <li role="presentation" class="active">
        <div class="labels"> Patient Experience</div>
        <a href="#Section1" aria-controls="home" role="tab" data-toggle="tab" style="min-width: 16em"></a>
      </li>
    </ul> -->
    <div class="row">
      <h1 class="carelon-page-title m-t-20">Patient Experience</h1>
    </div>


    <div class="dashboard-content">
      <div class="tab-pane dashboard-pane">
        <div class="row">
          <!-- <div class="col-md-12"> -->
          <div
            class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
            <label for="memberHealthPlan"><span class="required">*</span> <span class="measure-label">SITE</span></label>
            <cup-autocomplete class="form-control input-underline" [colWidth]="16" [(ngModel)]="selectedSite"
              [autoCompleteModel]="selectedSite" [autoCompleteDynamic]="true" [autoCompleteOptions]="sites"
              (autoCompleteModelChange)="setProviders($event)" emptyMessage='No Sites Found'
            [autoCompletePlaceholder]="'Select Site'"></cup-autocomplete>
          </div>

          <div
            class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
            style="position: relative;">
            <div>
              <label for="provider"><span class="required">*</span><span class="measure-label">Group Affiliation</span></label>
              <cup-autocomplete class="form-control input-underline"
                [colWidth]="16" [(ngModel)]="selectedProviderModel" [autoCompleteModel]="selectedProviderModel" emptyMessage='No Group Affiliation Found'
                [autoCompleteDynamic]="true" [autoCompleteOptions]="groupAffiliations"
                (autoCompleteModelChange)="onProvidersSubmit($event)"
                [autoCompletePlaceholder]="'Select Group Affiliation'">
              </cup-autocomplete>
            </div>
          </div>

        <!-- </div> -->

        <div class="col-md-12">
          <h3 class="patient-label">Upload Document</h3>
          <span class="smallheading">Please fill the following field and upload the document</span>

          <div class="box-body">
            <form [formGroup]="dataUpdateForm" (ngSubmit)="submitForm(dataUpdateForm.controls)" autocomplete="off">
              <div class="row">
                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* Document Type</label>
                  <!-- <input type="text" class="form-control" name="userData.firstName"
                  [ngModel]="userData.firstName" > -->
                  <select class="form-select placeholderFontSize" formControlName="documentTypeFormControl">
                    <option value="" disabled>Select Document Type</option>
                    @for (options of documentType[0]; track options) {
                      <option [value]="options.id">{{options.description}}</option>
                    }
                  </select>
                  @if (submitted && documentTypeFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (documentTypeFormControl.errors.required) {
                        <div><sup>*</sup>Document Type is required</div>
                      }
                    </div>
                  }

                </div>
                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* Survey Created by</label>
                  <!-- <input type="text" class="form-control" name="userData.lastName"
                  [ngModel]="userData.lastName"> -->
                  <select class="form-select placeholderFontSize" id="surveySelect" name="surveySelect"
                    (change)="changetextbox($event)" formControlName="surveyCreateFormControl">
                    <option value="" disabled >Select Survey Created by</option>
                    @for (options of surveyCreatedBy[0]; track options) {
                      <option [value]="options.id">{{options.description}}</option>
                    }
                  </select>

                  @if (submitted && surveyCreateFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (surveyCreateFormControl.errors.required) {
                        <div><sup>*</sup>Survey Created by is required</div>
                      }
                    </div>
                  }
                </div>

                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* Vendor Name</label>
                  <!-- <input type="text" class="form-control" id="vendorName" name="vendorN"
                  [disabled]="vendorCheck==true" formControlName="vendorNameFormControl"> -->
                  <!-- <input type="text" class="form-control" id="vendorName" name="vendorN"
                  formControlName="vendorNameFormControl" [formControl] ="vendorNameFormControl"> -->
                  <input type="text" placeholder="Enter Vendor Name" class="form-control placeholderFontSize" id="vendorName" name="vendorN"
                    formControlName="vendorNameFormControl" [class.disabled-input]="vendorCheck">

                  @if (submitted && vendorNameFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (vendorNameFormControl.errors.required) {
                        <div><sup>*</sup>Vendor Name is required</div>
                      }
                    </div>
                  }

                </div>
              </div>

              <div class="row">

                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* Status</label>
                  <select class="form-select placeholderFontSize" (change)="changeStatus($event)" formControlName="statusFormControl">
                    <option value="" disabled>Select Status</option>
                    @for (options of statusType[0]; track options) {
                      <option [value]="options.id">{{options.description}}</option>
                    }
                  </select>

                  @if (submitted && statusFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (statusFormControl.errors.required) {
                        <div><sup>*</sup>Status is required</div>
                      }
                    </div>
                  }
                </div>

                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* Effective Start Date</label>
                  <input type="date" class="form-control placeholderFontSize"
                    formControlName="startDateFormControl" [class.disabled-input]="vendorCheck1" (change)="onSelectionStartDate($event)">

                  @if (submitted && startDateFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (startDateFormControl.errors.required) {
                        <div><sup>*</sup>Start date is required</div>
                      }
                    </div>
                  }
                </div>

                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName">* End Date</label>
                  <input type="date" class="form-control placeholderFontSize"
                    formControlName="endDateFormControl" [class.disabled-input]="vendorCheck1" (change)="onSelectionEndDate($event)">
                  @if (submitted && endDateFormControl.errors) {
                    <div class="invalid-feedback">
                      @if (endDateFormControl.errors.required) {
                        <div><sup>*</sup>End date is required</div>
                      }
                    </div>
                  }
                </div>

              </div>

              <div class="row">

                <div class="col-xs-12 col-md-4 form-group">
                  <label class="enabled fieldName"> Additional Notes</label>
                  <!-- <input type="text" class="form-control" formControlName="additionalNotesFormControl"> -->
                  <textarea class="notestextArea" placeholder="Enter Notes" formControlName="messageFormControl" rows="4" cols="33"
                  formControlName="additionalNotesFormControl"></textarea>
                </div>
                <div class="col-md-1"></div>

                <div class="col-xs-12 col-md-7 form-group">
                  <label class="enabled fieldName">* Survey Point of Contact ( Email ID is Mandatory )</label>
                  <!-- <input type="text" class="form-control" > -->

                  <div class="row col-xs-16 col-sm-16 col-md-16 col-lg-16">
                    <!-- <span>
                    <h3 class="section-header">Interaction Data</h3>
                  </span> -->
                  <div style="margin-top: -12px;" class="d-flex p-0">
                    <div
                      class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 protocol-filter-header header-width">
                      Data
                    </div>
                    <div
                      class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 protocol-filter-header header-width">
                      Values
                    </div>
                    @if (!isReadOnly) {
                      <div class="form-group col-xs-1 col-sm-1 col-md-1 col-lg-1 protocol-filter-header"
                        >
                      </div>
                    }
                    <div class="form-group col-xs-5 col-sm-5 col-md-5 col-lg-5" style="background:transparent">

                    </div>
                  </div>
                </div>

                @for (skill of timecheck.controls; track skill; let i = $index) {
                  <div>
                    <div [formGroupName]="i">
                      <div class="row rowMargin">
                        <div class="col-md-3 dataSelectdropdown">
                          <select type="text" class="form-select placeholderFontSize" formControlName="dataControl"
                            (change)="onSelectionDay($event,i)">
                            <option selected="selected">Select</option>
                            @for (options of spocType[0]; track options) {
                              <option>{{options.description}}</option>
                            }
                          </select>
                        </div>
                        <div class="col-md-4">
                          <input type="text" class="form-control placeholderFontSize" formControlName="valueControl" (change)="onSelectionValue($event,i)">
                        </div>
                        <div
                          class="form-group col-xs-1 col-sm-1 col-md-1 col-lg-1 protocol-filter-typesdelete filter-delete  header-lastcol-width">
                          <i class="fa fa-times-circle" aria-hidden="true" (click)="removeTime(i)"></i>
                        </div>
                        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5" style="background:transparent">
                        </div>
                      </div>
                      <!-- <button (click)="removeTime(i)">Remove</button>  -->
                    </div>
                  </div>
                }

                <div class="row col-xs-16 col-sm-16 col-md-16 col-lg-16">
                  <div
                    class="row col-xs-7 col-sm-7 col-md-7 col-lg-7 protocol-filter-types-add add-filter-section footer-width">
                    <i class="fa fa-plus-circle" aria-hidden="true" (click)="addTime()"></i>
                  </div>
                  <div class="form-group col-xs-8 col-sm-8 col-md-8 col-lg-8" style="background:transparent">

                  </div>
                </div>



              </div>


            </div>

            <div class="row">
              <!-- <div class="col-xs-12 col-md-4 form-group">
              <label class="enabled">* Upload Document</label>
              <input type="File" class="form-control" id="" name=""
                formControlName="uploadDocument" (change)="this.onFilechange($event)">

              <div *ngIf="submitted && uploadDocument.errors" class="invalid-feedback">
                <div *ngIf="uploadDocument.errors.required"><sup>*</sup>Uploading Document is required</div>
              </div>

            </div> -->

            <div class="row col-md-5">
              <div style="text-align:left !important">
                <h3 class="section-header fieldName">Attachments</h3>
                <h5 style="color: red;">Note :</h5>
                <ul class="p-0">
                  <li style="font-size: 12px;">* Please ensure that the document attachment <b>does not contain any patient specific information/PHI. </b></li>
                  <li style="font-size: 12px;">* Maximum File size should be 25MB. </li>
                  <li style="font-size: 12px;">* Supported File Formats: Word (.doc, .docx), Excel (.xls, .xlsx), Picture (.jpg, .jpeg, .png ) and .PDF files </li>
                </ul>
              </div>

              @if (!isReadOnly) {
                <div id = "attachmentCont" class="row col-md-12 doccontainer attachment padMargin0" appDrananddrop (fileDropped)="onFileDropped($event)"
                  style="margin-top:5px">
                  <form [formGroup]="attachmentForm">
                    <input formControlName="attachmentControl" type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)"
                      [disabled]="isReadOnly" />
                  </form>
                  <div class="drag-and-drop-btn">
                    <div class=" col-md-12">
                      <span class="fieldName">Drag and drop file here</span>
                    </div>
                    <div class="col-md-12">
                      <span class="fieldName">or</span>
                    </div>
                    <div class="col-md-12">
                      <label for="fileDropRef">Browse file</label>
                    </div>
                  </div>
                </div>
              }

              @if (submitted && attachmentControl.errors) {
                <div class="invalid-feedback">
                  @if (attachmentControl.errors.required) {
                    <div><sup>*</sup>Uploading Document is required</div>
                  }
                </div>
              }

              @for (file of files; track file; let i = $index) {
                <div class="row col-md-12 files-list">
                  <div class="col-md-12 single-file">
                    <div class="file-icon" style="width: 50px">
                    </div>
                    @if (file.docID === '') {
                      <div class="info">
                        <h4 class="name">
                          {{ file?.name }}
                        </h4>
                        <p class="size">
                          {{ formatBytes(file?.size) }}
                        </p>
                      </div>
                    }
                    @if (file.docID !== '') {
                      <div class="info">
                        <a (click)="getUploadedDocument(file.docID);" style="font-size:12px;text-decoration:underline;color: #6a7dfe;cursor: pointer;">
                          <h4 class="nameLink">
                            {{ file?.name }}
                          </h4>
                        </a>
                      </div>
                    }
                    @if (file.docID === '') {
                      <div (click)="upload(file)">
                        <button type="button" class="btn green btn-sm" [disabled]="isReadOnly">
                          <span class="glyphicon glyphicon-upload" style="font-size:14px"></span> Upload
                        </button>
                      </div>
                    }
                    <div class="delete" (click)="deleteFile(i, file)">
                      <button type="button" class="btn btn-danger btn-sm" [disabled]="isReadOnly">
                        <span class="glyphicon glyphicon-trash" style="font-size:14px"></span> Delete
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6"></div>
                </div>
              }

            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-md-4 form-group">
              <button type="submit" class="btn submitBtn" style="float: right;margin-top: 15px;" >Submit
              </button>
            </div>
          </div>
        </form>
        <br>
          <br>
            <div class="row">
              <div class="col-md-12">
                <h3 class="heading patient-label">Patient Survey Result History :</h3>
                <div class="d-flex">
                  <label class="fieldName">Search By Group Affiliation :</label>
                  <input type="text" class="underlineSearch" (keyup)='search($event.target.value)'>
                </div>
              </div>
              <table class="table table-bordered">
                <thead class="protocol-filter-header">
                  <tr class="protocol-filter-header">
                    <th scope="col">Site</th>
                    <th scope="col">Group Affiliation</th>
                    <th scope="col">Submitted By</th>
                    <th scope="col">Document Type</th>
                    <th scope="col">Survey Created By</th>
                    <th scope="col">Vendor Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <!-- <th scope="col">Document Name</th> -->
                    <th scope="col">Submitted Date</th>
                    <th scope="col">Additional Notes</th>
                    <th scope="col">PatientExperience Notes</th>
                    <th scope="col">Decision Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor = "let item of filterData| paginate: { itemsPerPage: 5, currentPage: p } as results;">
                    <td>{{item.siteName}}</td>
                    <td>{{item.groupAffiliationName}}</td>
                    <td>{{item.ppUsername}}</td>
                    <td>{{item.documentType}}</td>
                    <td>{{item.surveyCreatedBy}}</td>
                    <td>{{item.vendorName}}</td>
                    <td>{{item.submissionStatus}}</td>
                    <td>{{item.startDate}}</td>
                    <td>{{item.endDate}}</td>
                    <td>{{item.uploadedDate}}</td>
                    <td>{{item.providerNotes}}</td>
                    <td>{{item.patientExperienceNotes}}</td>
                    <td>{{item.decisionStatus}}</td>
                  </tr>

                  <tr align="center" class="paginationTab">
                    <td colspan="14">
                      <pagination-controls (pageChange)="p = $event"></pagination-controls>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</div>
</div>


<div class="modal fade" id="docErrorModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="background-color:white;padding: 10px;">
        Upload Failed
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

      </div>
      <div class="modal-body">
        <span style="text-align:center;">Uploading document failed, please try again.</span>
      </div>
      <div class="modal-footer  d-flex justify-content-center">
        <div class="container-contact100-form-btn  d-flex justify-content-center">
          <button type="button"class="btn green buttonInfo" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="alertModal" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content alertPopup">
      <div class="modal-header" style="background-color:white">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row imgContainer">
          <img src="../../../assets/images/icons/Error.svg" alt="Success">
        </div>
        <p class="text">{{ message }}</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">

        <button type="button" data-bs-dismiss="modal"
        class="btn carelon-primary-btn">Close</button>

      </div>
    </div>
  </div>


  <br><br><br><br>
  <app-footer ></app-footer>
</div>



